import landingPages from "../constants/landingPages";
import {
  bypatruljen,
  bypatruljenAll,
  ileggelseadmin,
  innsyn,
  innsynAll,
  juridisk,
  juridiskAll,
  skiftlogg,
  stedfortrederDriftsleder,
} from "../constants/roles";
import { authorized } from "./authorizationUtils";

import sitePaths from "../constants/sitePaths";

export const getLandingPage = () => {
  if (authorized([ileggelseadmin])) {
    return landingPages.ileggelseAdmin;
  }
  if (authorized([stedfortrederDriftsleder])) {
    return landingPages.stedfortrederDriftsleder;
  }
  if (authorized(bypatruljenAll)) {
    return landingPages.bypatruljen;
  }
  if (authorized(juridiskAll)) {
    return landingPages.juridisk;
  }
  if (authorized(innsynAll)) {
    return landingPages.innsyn;
  }

  if (authorized([skiftlogg])) {
    return landingPages.skiftlogg;
  }

  return sitePaths.login;
};

export const getRedirectPath = (path) => {
  switch (path) {
    case sitePaths.innsyn.shortUrl:
      if (
        authorized([
          ...bypatruljenAll,
          ...juridiskAll,
          stedfortrederDriftsleder,
        ])
      ) {
        return sitePaths.innsyn.motorvogn.shortUrl;
      } else if (
        authorized([
          innsyn.vaktsentralen,
          innsyn.serviceavdeling,
          innsyn.kemnerkontoret,
          innsyn.seksjonssjefVaktsentralen,
        ])
      ) {
        return sitePaths.innsyn.ileggelser.oversikt;
      }
      return getLandingPage();
    case sitePaths.rapporter.shortUrl:
      if (
        authorized([
          bypatruljen.saksbehandler,
          bypatruljen.saksbehandleradmin,
          bypatruljen.avdelingdirektor,
          bypatruljen.seksjonssjefStab,
          bypatruljen.seksjonssjef,
          bypatruljen.driftleder,
          ...Object.values(juridisk),
        ])
      ) {
        return sitePaths.rapporter.ventilstillinger.oversikt;
      } else if (authorized([stedfortrederDriftsleder])) {
        return sitePaths.rapporter.skiftlogg.oversikt;
      }
      return getLandingPage();
    default:
      return getLandingPage();
  }
};
